export { default as TwoColumn } from './TwoColumn';
export type { Props } from './TwoColumn';
